// extracted by mini-css-extract-plugin
export default {"input":"TodoEditor_input__faPjh","button":"TodoEditor_button__+hXLT"};